import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';;

@Component({
  selector: 'app-vacancy-info-card',
  templateUrl: './vacancy-info-card.component.html',
  styleUrls: ['./vacancy-info-card.component.scss']
})
export class VacancyInfoCardComponent implements OnInit {

  @Input() vacancy: any;

  @Output() onConfirm: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }

  public confirm(){
    this.onConfirm.emit(this.vacancy);
  }
}
